import authService from "../services/authService";
import { useMutation } from "react-query";


const useGetProperty = (propertyId, oData) => {
  return useMutation((oProperty) => authService.getProperty(propertyId, oProperty), {
    onSuccess: (data) => oData(data),
  });
};

const useSubmitReview = (oData) => {
  return useMutation((oProperty) => authService.submitReview(oProperty), {
    onSuccess: (data) => {
      if (typeof oData === 'function') {
        oData(data);
      }
    },
  });
};

const useTrackRating = (oData) => {
  return useMutation((oProperty) => authService.trackRating(oProperty), {
    onSuccess: (data) => {
      if (typeof oData === 'function') {
        oData(data);
      }
    },
  });
};

const authQueries = {
  useGetProperty,
  useSubmitReview,
  useTrackRating,
};

export default authQueries;


